export default "__VITE_ASSET__a9d3f1e6__"